import { gql } from '@apollo/client'

export type Filters = {
  includeNonCompletionActivities: boolean
  includeCompletionActivities: boolean
}

export type QueryVars = {
  userId: string
  customerId: string
  startDate: string
  endDate: string
  limit: number
  offset: number
  filters?: Filters
}

export type ActivityTypeResponse = 'chase' | 'verify' | 'modify' | 'overallVerify' | null

export type SectionNameResponse = 'identity' | 'credit' | 'income' | 'residential' | null

export type ActivityResponse = {
  activityId: string
  subjectId: string
  customerId: string
  userId: string
  message: string
  details: string
  type: ActivityTypeResponse
  sectionName: SectionNameResponse
  createdAt: string
}

export type Response = {
  getActivitiesForUser: {
    total: number
    offset: number
    results: ActivityResponse[]
  }
}

const query = gql`
  query (
    $userId: String!
    $customerId: String!
    $startDate: String!
    $endDate: String!
    $limit: Int!
    $offset: Int!
    $filters: GetActivitiesForUserFilters
  ) {
    getActivitiesForUser(
      userId: $userId
      customerId: $customerId
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      total
      offset
      results {
        activityId
        subjectId
        customerId
        userId
        message
        details
        type
        sectionName
        createdAt
      }
    }
  }
`

export default query
